module.exports = __webpack_public_path__ + "resources/icon-check.258237210a346cfb.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-gift/img/icon-check.png
// module id = 778
// module chunks = 0 1